const proxy_enabled = process.env.NODE_ENV === 'development';

let env : any;
if (proxy_enabled) {
  env = Object.assign({}, env, {
    proxy_enabled,
    api_host: process.env.VUE_APP_API_HOST,
    chatwoot_host: process.env.VUE_APP_CHATWOOT_HOST,
    chatwoot_api_access_token: process.env.VUE_APP_CHATWOOT_API_ACCESS_TOKEN,
    chatwoot_account_id: process.env.VUE_APP_CHATWOOT_ACCOUNT_ID,
    chatwoot_inbox_id: process.env.VUE_APP_CHATWOOT_INBOX_ID,
    chatwoot_inbox_identifier: process.env.VUE_APP_CHATWOOT_INBOX_IDENTIFIER
  });
  (window as any).config = env;
} else {
  env = (window as any).config;
}
export default env;
